import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    img {
        width: 24px;
        height: 24px;
        margin: 0;
    }

    div {
        flex-grow: 1;
        padding: 0 24px;
    }

    h3 {
        font-size: 16px;
        font-weight: 400;
        line-height: 19px;
        color: #081717;
        margin: 0 0 4px 0;
    }

    p {
        color: #7A8585;
        font-size: 14px;
        font-weight: 400;
        margin: 0;
    }
`

const IconPlusText = ({ small, icon, title, text }) => {
    return (
        <Wrapper>
            <img src={icon} alt={title} />
            <div>
                {title && <h3>{title}</h3>}
                <p>{text}</p>
            </div>
        </Wrapper>
    )
}

export default IconPlusText